module.exports = __webpack_public_path__ + "front/img/b39.e69345fa.jpg";